import React, { Fragment, useMemo, useState } from "react";
import {
    MDBBtn,
    MDBIcon,
    MDBSwitch,
    MDBTooltip
} from 'mdb-react-ui-kit';
import { useRef } from "react";
import DropdownSelect from "./DropdownSelect";
import { IdeaBoxEntry, VisualisationAttribute } from "konect-model";
import { Insight } from "konect-model";
import "./IdeaBoxRow.css";

interface IdeaBoxRowProps {
    keyy: string;
    entry: IdeaBoxEntry | any;
    props: any;
    onInitEdit: (event : any, entry : IdeaBoxEntry) => void;
    goToTask: (id: string) => void;
    editEntry: (event: any, entry: IdeaBoxEntry) => void;
    duplicateEntry: (event : Event, entry : IdeaBoxEntry) => void;
    deleteEntry: (event : Event, entry : IdeaBoxEntry) => void;
    onUpdate: (event : any) => void;
    onAbort: (event: MouseEvent) => void;
    isInconsistent: boolean; 
    hasTask: boolean;
    insights: Insight[];
}

interface IdeaBoxEditableRowProps {
    keyy: string;
    entry: IdeaBoxEntry | any;
    props: any;
    onUpdate: (event : any) => void;
    onAbort: (event: MouseEvent) => void;
    insights: Insight[];
    hasTask: boolean;
}

const IdeaBoxRow = ({
    keyy,
    entry,
    props,
    onInitEdit,
    goToTask,
    editEntry,
    duplicateEntry,
    deleteEntry,
    isInconsistent,
    hasTask,
    insights,
    onUpdate,
    onAbort
}: IdeaBoxRowProps) => {

    const renderInformation = useMemo(() => {
        return <></>
        //return <td key={"td4_" + keyy}>{entry.visualLevel}</td>
    }, [entry]);  // eslint-disable-line react-hooks/exhaustive-deps

    const renderInteraction = useMemo(() => {
        return <Fragment>
            <td style={{ textAlign: "center" }}>
                {entry.isFailsafe ?
                    <MDBSwitch className={"bg-danger"} disabled defaultChecked /> :
                    <MDBSwitch disabled value={entry.isFailsafe} />}
            </td>
            <td key={"td5_" + keyy}>{entry.restrictions}</td>
        </Fragment>
    }, [entry, props]);  // eslint-disable-line react-hooks/exhaustive-deps

    const handleDropdownClick = (e : MouseEvent) => {
        e.preventDefault();
        onUpdate(e);
    }

    return (
        <tr className="ideabox-row editable-row" id={"tr_" + keyy} key={"tr_" + keyy} onClick={(event) => onInitEdit(event, entry)} style={{ cursor: "pointer", height: "54px" }}>
            <td>
                <div>{entry.task.name} {!hasTask && <MDBTooltip tag='span' wrapperClass='d-inline-block' title='This task does not exist anymore.'>
                <i className="fas fa-exclamation card-exclamation"></i></MDBTooltip>}</div>
            </td>
            <td>
                <div>{entry.interfaceElement}</div>
            </td>
            <td>
                <DropdownSelect
                    type="insight"
                    value={entry.insight && entry.insight.name}
                    defaultValue={"select insight"}
                    items={insights}
                    onClick={handleDropdownClick}
                />
            </td>
            <td>
                {entry.insight &&
                    <DropdownSelect
                        type="selectedAttribute"
                        value={getAttributeLabel(entry)} 
                        defaultValue={"select attribute"}
                        items={entry.availableAttributes as VisualisationAttribute[]}
                        onClick={handleDropdownClick}
                    />
                }
            </td>
            <td style={{ textAlign: "center" }}>
                <MDBTooltip tag='span' wrapperClass='d-inline-block' title='Go to task'>
                    <MDBBtn floating className='mx-1' color='bright' onClick={() => {goToTask(entry.task.id)}}>
                        <MDBIcon fas icon='sign-in-alt' />
                    </MDBBtn>
                </MDBTooltip>
                <MDBTooltip tag='span' wrapperClass='d-inline-block' title='Edit task'>
                    <MDBBtn floating className='mx-1' color='warning' onClick={(event:Event) => {editEntry(event, entry)}}>
                        <MDBIcon fas icon='pen' style={{color: "#343a40"}}/>
                    </MDBBtn>
                </MDBTooltip>
                <MDBTooltip tag='span' wrapperClass='d-inline-block' title='Duplicate'>
                    <MDBBtn floating className='mx-1' color='primary' onClick={(event:Event) => {duplicateEntry(event, entry)}}>
                        <MDBIcon fas icon='copy' />
                    </MDBBtn>
                </MDBTooltip>
                <MDBTooltip tag='span' wrapperClass='d-inline-block' title='Delete'>
                    <MDBBtn floating className='mx-1' color='danger' onClick={(event:Event) => {deleteEntry(event, entry)}}>
                        <MDBIcon fas icon='trash' />
                    </MDBBtn>
                </MDBTooltip>
            </td>
        </tr>
    );
};

export default IdeaBoxRow;

export const IdeaBoxEditableRow = ({
    keyy,
    entry,
    props,
    onUpdate,
    onAbort,
    insights,
    hasTask
} : IdeaBoxEditableRowProps) => {

    const inputRef = useRef<any>();

    const updateText = (e : any) => {
        clearTimeout(inputRef.current);
        inputRef.current = setTimeout(() => {
            onUpdate(e);
        }, 500)
    }

    const handleDropdownClick = (e : MouseEvent) => {
        e.preventDefault();
        onUpdate(e);
    }

    const [toggle, setToggle] = useState<boolean>(entry.isFailsafe);

    const renderInformation = useMemo(() => {
           /* 
        return <Fragment>
            <td>
                {entry.visualLevel}
            </td>
        </Fragment>
        */
        return <></>
    }, [entry]);  // eslint-disable-line react-hooks/exhaustive-deps

    const renderInteraction = <Fragment>
        <td style={{ textAlign: "center" }}>
            {toggle ? <MDBSwitch id='failsafetyInput'
                name={"isFailsafe"}
                defaultChecked
                onChange={() => { setToggle(!toggle); onUpdate({ target: { name: "isFailsafe", value: !toggle } }) }}
            /> :
                <MDBSwitch id='failsafetyInput'
                    name={"isFailsafe"}
                    onChange={() => { setToggle(!toggle); onUpdate({ target: { name: "isFailsafe", value: !toggle } }) }}
                />}
        </td>
        <td>
            <input
                type="text"
                placeholder="Restriction"
                name="restrictions"
                defaultValue={entry.restrictions}
                onChange={updateText}
            />
        </td>
    </Fragment>

    return ( //@ts-ignore
        <tr className="editable-row" bgcolor="#e8e8e8" key={keyy}>
            <td>
                <div>{entry.task.name} {!hasTask && <MDBTooltip tag='span' wrapperClass='d-inline-block' title='This task does not exist anymore.'>
                <i className="fas fa-exclamation card-exclamation"></i></MDBTooltip>}</div>
            </td>
            <td>
                <div>{entry.interfaceElement}</div>
            </td>
            <td>
                <DropdownSelect
                    type="insight"
                    value={entry.insight && entry.insight.name}
                    defaultValue={"select insight"}
                    items={insights}
                    onClick={handleDropdownClick}
                />
            </td>
            {props.type === "INFORMATION" ? renderInformation : renderInteraction}
            <td>
                {entry.insight &&
                    <DropdownSelect
                        type="selectedAttribute"
                        value={getAttributeLabel(entry)} 
                        defaultValue={"select attribute"}
                        items={entry.availableAttributes as VisualisationAttribute[]}
                        onClick={handleDropdownClick}
                    />
                }
            </td>
            <td style={{ textAlign: "center" }}>
                <MDBTooltip tag='span' wrapperClass='d-inline-block' title='Submit'>
                    <MDBBtn floating className='mx-1' color='success' type="submit">
                        <MDBIcon fas icon='check' />
                    </MDBBtn>
                </MDBTooltip>
                <MDBTooltip tag='span' wrapperClass='d-inline-block' title='Cancel'>
                    <MDBBtn floating className='mx-1' color='danger' onClick={onAbort}>
                        <MDBIcon fas icon='times' />
                    </MDBBtn>
                </MDBTooltip>
            </td>
        </tr>
    );
};

export const getAttributeLabel = (entry : IdeaBoxEntry) => {
    let attributeLabel = "";
    if (entry.insight && entry.selectedAttribute && entry.availableAttributes) {
        attributeLabel += entry.selectedAttribute.name;
        attributeLabel += " (" + entry.availableAttributes.findIndex((att : VisualisationAttribute) => att.id === entry.selectedAttribute.id) + ")";
    }
    return attributeLabel;
}